import type { IFiltersLocalization } from '../../types/data_table';

/**
 * Provides default filter localization strings based on language.
 * These are the common strings used across all DataTable filters.
 */
export const getDefaultFiltersLocalization = (
  lang: 'en' | 'ar'
): IFiltersLocalization => {
  const defaults: Record<'en' | 'ar', IFiltersLocalization> = {
    en: {
      all: 'All',
      none: 'None',
      selected: 'Selected',
      apply: 'Apply',
      resetFilters: "Reset filters",
    },
    ar: {
      all: 'الكل',
      none: 'لا شيء',
      selected: 'المحدد',
      apply: 'تطبيق',
      resetFilters: "إعادة تعيين الفلاتر"
    },
  };

  return defaults[lang];
};

/**
 * Merges user-provided localization with defaults.
 * User-provided values take precedence over defaults.
 */
export const mergeFiltersLocalization = (
  lang: 'en' | 'ar',
  userLocalization?: IFiltersLocalization
): IFiltersLocalization => {
  const defaults = getDefaultFiltersLocalization(lang);
  return {
    ...defaults,
    ...(userLocalization || {}),
  };
};
